import { render } from "./VerifoneSettingsTab.vue?vue&type=template&id=165b33c4"
import script from "./VerifoneSettingsTab.vue?vue&type=script&lang=js"
export * from "./VerifoneSettingsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__